module.exports = __webpack_public_path__ + "img/fullscreen.8d7ab117.svg";